

export const replaceParams = (template: string, params: any[]) => {
    let result = template;
    for (const param of params) {
        result = result.replace(/{}/, param);
    }
    return result;
}

export const capitalize = (str: string) => {
    return str.length === 0
        ? str
        : str[0].toUpperCase() + str.slice(1);
}


export const extractValue = (key: string, item: any) => {
    let value = item;
    const path = key.split('.');

    path.forEach(key => {
        value = value == null ? null : value[key];
    });

    return value;
}


export const titleCase = (id: string): string => {

    return id == null ? ''
        : id
            .replace('_', ' ')
            .toLowerCase()
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
}

export const replace = (value: string, source: string, destination: string) => {
    return value == null
        ? null : value.replace(source, destination);
}
